import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import useLodStore from "store/lod";
import useLodGrpListStore from "store/lodGrpList";
import TableRow from "./tableRow";

type IProsp = {
  children?: ReactNode;
};

export default function LodInfRow({ children }: IProsp) {
  const { t } = useTranslation();

  const lodGrpList = useLodGrpListStore((state) => state.lodGrpList);
  const lod = useLodStore((state) => state.lod);

  return (
    <TableRow title={t("row_ttl_lod_inf")}>
      <ul>
        <li>
          <label htmlFor="">{t("lbl_lod_grp_nm_cmm")}</label>
          <input
            type="text"
            defaultValue={lodGrpList[0]?.lodGrpNm}
            readOnly
            disabled
          />
        </li>
        <li>
          <label htmlFor="">{t("lbl_lod_nm_cmm")}</label>
          <input
            type="text"
            defaultValue={lod?.lodNm ?? "서울 호텔"}
            readOnly
            disabled
          />
        </li>
        {children}
      </ul>
    </TableRow>
  );
}
